// extracted by mini-css-extract-plugin
module.exports = {"cardshare-checkbox":"card-share_cardshare-checkbox__1ykKO"};